module.exports = __webpack_public_path__ + "static/media/requests.fd159a14.svg";